export function removeProtocol(url: string) {
  return url.replace(/^https?:\/\//, '');
}

export function buildUrl(url: string, params: Record<string, string>) {
  const result = new URL(url, location.href);

  Object.entries(params).forEach(([key, value]) => {
    result.searchParams.set(key, value);
  });

  return result.toString();
}
